<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Pages" subtitle="Manage pages that appear across the various sites on the platform." />

	<app-content-filters>

		<app-content-filters-search v-model="filter.search" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no pages found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Name" />
				<app-table-column text="Last Updated" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.name" />
					<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			layout: 'auto 200px',
			endpoint: 'pages/pages',
			live: 'pages/pages',
			edit: 'Pages.Browse.Edit'
		}

	}

}

</script>

<style scoped>

</style>